export default {
    selectOptionsWrapper: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        width: "100%",
        margin: "20px"
    },
    cardsContainer: {
        height: "400px",
        margin: "10px",
        display: "flex",
        flexWrap: "wrap",
        rowGap: "10px",
        columnGap: "10px",
        overflow: "auto",
        scrollBehavior:"smooth"
    },
    cardBody: {
        height: 'fit-content'
    },
    singleOptionContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "10px",
        width: "280px",
        height: "60px",
        cursor:"pointer"
    },
    labelContainer: {
        flex: "1",
        marginLeft: "10px"
    },
    optionLabel: {
        fontWeight: "400",
        fontSize: "20px",
        lineHeight: "24px",
        color: "rgb(38, 38, 38)",
    },
    footerSyles:{
        paddingRight:'70px'
},
    searchContainer: {
        display: "flex",
        justifyContent: "flex-end",
        width: "fit-content",
    },
    noRecordsDiv: {
        marginTop: "30px",
    }
}